export { default } from './MiddleDot';
